import { render, staticRenderFns } from "./four.vue?vue&type=template&id=afd6f6e8&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=afd6f6e8&prod&lang=css"
import style1 from "./four.vue?vue&type=style&index=1&id=afd6f6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6f6e8",
  null
  
)

export default component.exports